import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { useSelector, shallowEqual } from "react-redux"
import { Link, withRouter } from "react-router-dom"

import bibliotecaNormas from "../../assets/images/menu/bibliotecaNormas_renewed.png"
import catalogo from "../../assets/images/menu/catálogos_updated.png"
import labCitec from "../../assets/images/menu/lab_Citec_updated.png"
import labMovil from "../../assets/images/menu/labMoviles_renewed.png"
import registroMuestras from "../../assets/images/menu/registro_muestras_updated.png"
import resultados from "../../assets/images/menu/resultados_updated.png"
import roi from "../../assets/images/menu/roi_renewed.png"
import userManagement from "../../assets/images/menu/user_updated.png"
import { userRoles } from "../../shared"

import { Tooltip } from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { staticRoutes } from '../../routes/staticRoutes'

const SidebarContent = props => {

  const [tooltipCatalogOpen, setTooltipCatalogOpen] = useState(false);
  const [tooltipUserManagementOpen, setTooltipUserManagementOpen] = useState(false);
  const [tooltipLabCitecOpen, setTooltipLabCitecOpen] = useState(false);
  const [tooltipLabMovilOpen, setTooltipLabMovilOpen] = useState(false);

  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

  const ref = useRef();

  const labtypes = useSelector(state => state.labType.labtypes, shallowEqual);

  const onClickCitec = () => {
    localStorage.setItem("lType", JSON.stringify('CITEC'));
    localStorage.setItem("lId", JSON.stringify(labtypes?.find(x => x.name === 'CITEC')?.id ?? ''));
    props.history.push('/labCitec')
  }

  const onClickMoviles = () => {
    localStorage.setItem("lType", JSON.stringify('Móvil'));
    localStorage.setItem("lId", JSON.stringify(labtypes?.find(x => x.name === 'Móvil')?.id ?? ''));
    props.history.push('/labmoviles')
  }

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }
    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement
      if (parent2) {
        parent2.classList.add("mm-show")
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add("mm-active")
          parent3.childNodes[0].classList.add("mm-active")
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add("mm-show")
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show")
              parent5.childNodes[0].classList.add("mm-active")
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    new MetisMenu("#side-menu")
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }

  }, [props.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>

      <SimpleBar style={{ maxHeight: "100%" }} ref={ref} className="sidebar-menu-scroll">
        <div id="sidebar-menu">
          {
            role === userRoles.laboratorist ?
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link to="/#" className="waves-effect m-0 p-0 rounded-0">
                    <div className="d-flex align-items-center justify-content-center text-white bg-primary">
                      <span className="mdi mdi-24px mdi-home-outline"></span>
                    </div>
                  </Link>
                </li>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-2 mb-2' />

                <li className="d-flex justify-content-center">
                  <span className="text-primary">Servicios de Laboratorio</span>
                </li>

                <li className="d-flex justify-content-center">
                  <button onClick={onClickCitec} style={{ backgroundColor: 'white', border: 'white' }}>
                    <img src={labCitec} id="TooltipLabCitec" alt="" height="30" />
                  </button>
                </li>

                <Tooltip
                  isOpen={tooltipLabCitecOpen}
                  placement="right"
                  target="TooltipLabCitec"
                  toggle={() => { setTooltipLabCitecOpen(!tooltipLabCitecOpen) }}>
                  Laboratorio CITEC
                </Tooltip>

                <li className="d-flex justify-content-center">
                  <button onClick={onClickMoviles} style={{ backgroundColor: 'white', border: 'white' }}>
                    <img src={labMovil} id="TooltipLabMovil" alt="" height="30" />
                  </button>
                </li>

                <Tooltip
                  isOpen={tooltipLabMovilOpen}
                  placement="right"
                  target="TooltipLabMovil"
                  toggle={() => { setTooltipLabMovilOpen(!tooltipLabMovilOpen) }}>
                  Laboratorio Móvil
                </Tooltip>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                <li className="d-flex justify-content-center">
                  <span className="text-primary">Biblioteca de Normas</span>
                </li>

                <li className="d-flex justify-content-center">
                  <Link to="/normLibrary" className="waves-effect p-0">
                    <img src={bibliotecaNormas} alt="" height="30" />
                  </Link>
                </li>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                <li className="d-flex justify-content-center">
                  <span className="text-primary">Registro de Muestras</span>
                </li>

                <li className="d-flex justify-content-center">
                  <Link to={staticRoutes.labRequestSamples.base} className="waves-effect p-0">
                    <img src={registroMuestras} alt="" height="30" />
                  </Link>
                </li>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                <li className="d-flex justify-content-center">
                  <span className="text-primary">ROI</span>
                </li>

                <li className="d-flex justify-content-center">
                  <Link to="/roi" className="waves-effect p-0">
                    <img src={roi} alt="" height="30" />
                  </Link>
                </li>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                <li className="d-flex justify-content-center">
                  <span className="text-primary">Resultados</span>
                </li>

                <li className="d-flex justify-content-center">
                  <Link to="/results" className="waves-effect p-0">
                    <img src={resultados} alt="" height="30" />
                  </Link>
                </li>

                <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-2 mb-2' />


              </ul> :
              role === userRoles.technicalAdvisor ?
                <ul className="metismenu list-unstyled" id="side-menu">
                  <li>
                    <Link to="/#" className="waves-effect m-0 p-0 rounded-0">
                      <div className="d-flex align-items-center justify-content-center text-white bg-primary">
                        <span className="mdi mdi-24px mdi-home-outline"></span>
                      </div>
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Servicios de Laboratorio</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <button onClick={onClickCitec} style={{ backgroundColor: 'white', border: 'white' }}>
                      <img src={labCitec} id="TooltipLabCitec" alt="" height="30" />
                    </button>
                  </li>

                  <Tooltip
                    isOpen={tooltipLabCitecOpen}
                    placement="right"
                    target="TooltipLabCitec"
                    toggle={() => { setTooltipLabCitecOpen(!tooltipLabCitecOpen) }}>
                    Laboratorio CITEC
                  </Tooltip>

                  <li className="d-flex justify-content-center">
                    <button onClick={onClickMoviles} style={{ backgroundColor: 'white', border: 'white' }}>
                      <img src={labMovil} id="TooltipLabMovil" alt="" height="30" />
                    </button>
                  </li>

                  <Tooltip
                    isOpen={tooltipLabMovilOpen}
                    placement="right"
                    target="TooltipLabMovil"
                    toggle={() => { setTooltipLabMovilOpen(!tooltipLabMovilOpen) }}>
                    Laboratorio Móvil
                  </Tooltip>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />


                </ul> :
                <ul className="metismenu list-unstyled" id="side-menu">
                  <li>
                    <Link to="/#" className="waves-effect m-0 p-0 rounded-0">
                      <div className="d-flex align-items-center justify-content-center text-white bg-primary">
                        <span className="mdi mdi-24px mdi-home-outline"></span>
                      </div>
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-2 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Configuraciones</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <Link to="/catalogs/menu" className="waves-effect p-0 ms-1">
                      <img src={catalogo} id="TooltipCatalogs" alt="" height="23" />
                    </Link>
                  </li>

                  <Tooltip
                    isOpen={tooltipCatalogOpen}
                    className="in"
                    placement="right"
                    target="TooltipCatalogs"
                    toggle={() => { setTooltipCatalogOpen(!tooltipCatalogOpen) }}>
                    Catálogos
                  </Tooltip>

                  <li className="d-flex justify-content-center">
                    <Link to="/catalogs/catalog/laboratory-staffs" className="waves-effect p-0 pt-2">
                      <img src={userManagement} id="TooltipUserManagement" alt="" height="30" />
                    </Link>
                  </li>

                  <Tooltip
                    isOpen={tooltipUserManagementOpen}
                    placement="right"
                    target="TooltipUserManagement"
                    toggle={() => { setTooltipUserManagementOpen(!tooltipUserManagementOpen) }}>
                    Gestión de Usuarios
                  </Tooltip>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Servicios de Laboratorio</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <button onClick={onClickCitec} style={{ backgroundColor: 'white', border: 'white' }} >
                      <img src={labCitec} id="TooltipLabCitec" alt="" height="30" />
                    </button>
                  </li>

                  <Tooltip
                    isOpen={tooltipLabCitecOpen}
                    placement="right"
                    target="TooltipLabCitec"
                    toggle={() => { setTooltipLabCitecOpen(!tooltipLabCitecOpen) }}>
                    Laboratorio CITEC
                  </Tooltip>

                  <li className="d-flex justify-content-center">
                    <button onClick={onClickMoviles} style={{ backgroundColor: 'white', border: 'white' }}>
                      <img src={labMovil} id="TooltipLabMovil" alt="" height="30" />
                    </button>
                  </li>

                  <Tooltip
                    isOpen={tooltipLabMovilOpen}
                    placement="right"
                    target="TooltipLabMovil"
                    toggle={() => { setTooltipLabMovilOpen(!tooltipLabMovilOpen) }}>
                    Laboratorio Móvil
                  </Tooltip>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Biblioteca de Normas</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <Link to="/normLibrary" className="waves-effect p-0">
                      <img src={bibliotecaNormas} alt="" height="30" />
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Registro de Muestras</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <Link to={staticRoutes.labRequestSamples.base} className="waves-effect p-0">
                      <img src={registroMuestras} alt="" height="30" />
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">ROI</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <Link to="/roi" className="waves-effect p-0">
                      <img src={roi} alt="" height="30" />
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-1 mb-2' />

                  <li className="d-flex justify-content-center">
                    <span className="text-primary">Resultados</span>
                  </li>

                  <li className="d-flex justify-content-center">
                    <Link to="/results" className="waves-effect p-0">
                      <img src={resultados} alt="" height="30" />
                    </Link>
                  </li>

                  <hr style={{ background: '#E4E9F0', height: 3 }} className='mx-2 mt-2 mb-2' />

                </ul>
          }

        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
